import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map  } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Injectable()
export class SessionInterceptor implements HttpInterceptor {

  constructor(
    private readonly router: Router,
    private readonly storageService: StorageService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.body && +event.body.code === 401 ) {
            this.storageService.clear();
            this.router.navigate(['/login']);
            throw new Error(event.body.desc);
          }

          if (event.body && +event.body.code !== 200 ) {
            throw new Error(event.body.desc);
          }
        }

        return event;
      })
    );

  }
}
